'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = personalDetails;
exports.updateBlock = updateBlock;
exports.updateField = updateField;
var UPDATEBLOCK = 'personaldetails/UPDATEBLOCK';
var UPDATEFIELD = 'personaldetails/UPDATEFIELD';

var initialState = {
  name: false,
  email: false,
  dob: false,
  address: false,
  phone: false,
  bio: false,
  title: false,
  linkedin: false,
  website: false,
  github: false
};

function personalDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case UPDATEBLOCK:
      return {
        name: action.name,
        email: action.email,
        dob: action.dob,
        location: action.location,
        phone: action.phone,
        bio: action.bio,
        title: action.title,
        linkedin: action.linkedin,
        website: action.website,
        github: action.github
      };
    case UPDATEFIELD:
      console.log(action);
      var data = action.data;
      var field = action.field;
      var new_state = state;
      new_state[field] = data;
      return new_state;
    default:
      return state;
  }
}

function updateBlock(data) {
  return {
    type: UPDATEBLOCK,
    name: data.name,
    email: data.email,
    dob: data.dob,
    location: data.location,
    phone: data.phone,
    bio: data.bio,
    title: data.title,
    linkedin: action.linkedin,
    website: action.website,
    github: action.github
  };
}

function updateField(data, field) {
  return {
    type: UPDATEFIELD,
    data: data,
    field: field
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/personalDetails.js
// module id = 212
// module chunks = 0